export default [
  "icon-portal-AuthorityCenter-o",
  "icon-portal-Workflow",
  "icon-portal-portal",
  "icon-portal-operation",
  "icon-portal-Modular",
  "icon-portal-ModelingEngine",
  "icon-portal-MobileEngine",
  "icon-portal-Journal",
  "icon-portal-integration",
  "icon-portal-content",
  "icon-portal-CloudStore",
  "icon-portal-AuthorityCenter",
  "icon-portal-Workflow-o",
  "icon-portal-portal-o",
  "icon-portal-operation-o",
  "icon-portal-Modular-o",
  "icon-portal-ModelingEngine-o",
  "icon-portal-MobileEngine-o",
  "icon-portal-Journal-o",
  "icon-portal-integration-o",
  "icon-portal-content-o",
  "icon-portal-CloudStore-o",
  "icon-portal-blog",
  "icon-portal-blog-o",
  "icon-portal-car",
  "icon-portal-car-o",
  "icon-portal-common",
  "icon-portal-common-o",
  "icon-portal-cowork",
  "icon-portal-cowork-o",
  "icon-portal-crm",
  "icon-portal-crm-o",
  "icon-portal-cs",
  "icon-portal-cs-o",
  "icon-portal-demo",
  "icon-portal-demo-o",
  "icon-portal-doc",
  "icon-portal-doc-o",
  "icon-portal-email",
  "icon-portal-email-o",
  "icon-portal-fa",
  "icon-portal-fa-o",
  "icon-portal-home",
  "icon-portal-hrm",
  "icon-portal-hrm-o",
  "icon-portal-implement",
  "icon-portal-implement-o",
  "icon-portal-investigate",
  "icon-portal-investigate-o",
  "icon-portal-kpi",
  "icon-portal-kpi-o",
  "icon-portal-license",
  "icon-portal-license-o",
  "icon-portal-meeting",
  "icon-portal-meeting-o",
  "icon-portal-message",
  "icon-portal-schedule-o",
  "icon-portal-news",
  "icon-portal-news-o",
  "icon-portal-official",
  "icon-portal-official-o",
  "icon-portal-photo",
  "icon-portal-photo-o",
  "icon-portal-project",
  "icon-portal-project-o",
  "icon-portal-reportform",
  "icon-portal-reportform-o",
  "icon-portal-satisfaction",
  "icon-portal-satisfaction-o",
  "icon-portal-schedule",
  "icon-portal-si",
  "icon-portal-si-o",
  "icon-portal-store",
  "icon-portal-workflow",
  "icon-portal-ws",
  "icon-portal-ws-o",
  "icon-coms-message-o"
];



// WEBPACK FOOTER //
// ./ecology9/base/wea-browser-icons/data.js